import { FormAnswer } from "./FormAnswer";

export class QuestionAnswer
{
  questionAnswerId: number;
  questionId: number;
  questionText: string;
  answer: string;
  order: number;
  formAnswer: FormAnswer;
	}
